/* OPM auto-scroll — gentle ping-pong drift for horizontal rails.
   Applies to [data-autoscroll] (value = px per frame). Pauses on hover, touch
   and focus, resumes after idle. Stands down entirely for reduced-motion or
   the theme's animations switch (html.no-anim). */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (document.documentElement.classList.contains('no-anim')) return;

  function init() {
    document.querySelectorAll('[data-autoscroll]').forEach(function (rail) {
      if (rail.dataset.autoscrollInit) return;
      rail.dataset.autoscrollInit = '1';
      var speed = parseFloat(rail.dataset.autoscroll) || 0.3;
      var dir = 1, paused = false, idleTimer = null;

      function pause() {
        paused = true;
        clearTimeout(idleTimer);
        idleTimer = setTimeout(function () { paused = false; }, 3500);
      }
      ['pointerenter', 'pointerdown', 'touchstart', 'focusin', 'wheel'].forEach(function (ev) {
        rail.addEventListener(ev, pause, { passive: true });
      });

      function tick() {
        if (!paused && rail.scrollWidth > rail.clientWidth + 4) {
          rail.scrollLeft += speed * dir;
          var max = rail.scrollWidth - rail.clientWidth;
          if (rail.scrollLeft >= max - 1) dir = -1;
          else if (rail.scrollLeft <= 1) dir = 1;
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
